import { useCallback } from 'react';
import { MAX_PERCENTAGE } from 'data/global';
import useProgress from './useProgress';
import { getPercentageWithTwoDecimals } from 'utils';

const DURATION = 1000;
const INTERVAL = 50;

const useProgressTimer = (duration = DURATION, interval = INTERVAL) => {
  const { progress, isInProgress, setProgress } = useProgress();

  const startTimer = useCallback(() => {
    setProgress(0);

    let currentValue = 0;

    const timerId = setInterval(() => {
      currentValue += interval;

      const percentage = Math.min(
        getPercentageWithTwoDecimals(currentValue, duration),
        MAX_PERCENTAGE,
      );

      setProgress(percentage);

      if (currentValue >= duration) {
        clearInterval(timerId);
      }
    }, interval);

    return () => {
      clearInterval(timerId);
      setProgress(0);
    };
  }, [duration, interval, setProgress]);

  return { progress, isInProgress, startTimer };
};

export default useProgressTimer;
